import { createStore, createTypedHooks } from 'easy-peasy';
import { StoreState, storeState } from './store';
import { logger } from './logger';

const typedHooks = createTypedHooks<StoreState>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
export const useStore = typedHooks.useStore;

export const store = createStore(storeState, {
  name: 'Web Video Player Store',
  middleware: [logger],
  devTools: false,
});

Object.defineProperty(store, 'state', { get: store.getState });
Object.defineProperty(store, 'actions', { get: store.getActions });
